module.exports = __webpack_public_path__ + "img/Policies.71936019.svg";